import {BrowserModule} from '@angular/platform-browser';
import {APP_INITIALIZER, NgModule} from '@angular/core';

import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {RouterModule} from '@angular/router';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {AppComponent} from './app.component';
import {MainComponent} from './main.component';
import {appRoutes} from './app.route';
import {MaskSelectComponent} from './mask-select.component';
import {CoreModule} from './core/core.module';
import {Principal} from './core/auth/principal.service';
import {AuthInterceptor} from './core/auth/auth.interceptor';
import {OktaAuthService} from './core/auth/okta-auth.service';
import {ServicesModule} from './shared/services/services.module';
import {SharedComponentsModule} from './shared/components/components.module';
import {RouterExtService} from './core/services/router-ext.service';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MixpanelService } from './shared/services/mixpanel.service';

export function initializeMixpanel(mixpanel: MixpanelService): () => void {
  return () => mixpanel.initialize();
}

export function initializeOktaAuth(oktaAuthService: OktaAuthService): () => Promise<void> {
  return () => oktaAuthService.handleCallbackIfPresent()
    .catch((err) => {
      sessionStorage.setItem('okta_login_error', err?.message || 'Okta login failed');
    })
    .then(() => undefined);
}

@NgModule({
  declarations: [
    AppComponent,
    MainComponent,
    MaskSelectComponent,
  ],
  imports: [
    BrowserModule,
    CoreModule,
    ServicesModule,
    SharedComponentsModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(
      appRoutes,
      {
        useHash: true
      }
    )
  ],
  providers: [
    Principal,
    RouterExtService,
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
    { provide: MatDialogRef, useValue: {} },
    { provide: MAT_DIALOG_DATA, useValue: [] },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeMixpanel,
      deps: [MixpanelService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeOktaAuth,
      deps: [OktaAuthService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
